module.exports = __webpack_public_path__ + "img/intermediate.c50c79d0.svg";